// extracted by mini-css-extract-plugin
module.exports = {"tooltipContainer":"customTooltip_tooltipContainer__EEZGy","tooltip":"customTooltip_tooltip__3DblL","truncatedText":"customTooltip_truncatedText__JmY1a"};